import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, LinkButton, Icon } from 'src/components';
import { ZENDESK_WEB_MICROPHONE_ARTICLE } from 'src/constants/links.const';
import { PronunciationViewWrapper } from '../PronunciationViewWrapper';
import * as S from './styles';

const msgs = defineMessages({
  micPermissionPromptTitle: { id: 'pronunciationBuddy_microphoneAccess_title' },
  micPermissionPromptDescription: { id: 'pronunciationBuddy_microphoneAccess_description' },
  micPermissionCta: { id: 'pronunciationBuddy_microphoneAccess_grantCTA' },
  micPermissionDenied: { id: 'communicate_microphonepermissions_alert' },
  micPermissionDeniedCta: { id: 'pronunciationBuddy_microphoneAccess_moreInfoCTA' },
});

export const MicPermissionsView: FC<{
  isDenied: boolean;
  onClick: () => void;
  compact?: boolean;
}> = ({ isDenied, onClick, compact = false }) => {
  const intl = useIntl();

  if (isDenied) {
    return (
      <PronunciationViewWrapper $background="none">
        <S.Layout $compact={compact}>
          <S.MicIconWrapper>
            <Icon name="microphoneOutline" />
          </S.MicIconWrapper>
          <S.TextsWrapper>
            <S.Title>{intl.formatMessage(msgs.micPermissionDenied)}</S.Title>
          </S.TextsWrapper>
          <S.ButtonWrapper>
            <LinkButton
              buttonType="primary"
              buttonSize={compact ? 'medium' : 'large'}
              href={ZENDESK_WEB_MICROPHONE_ARTICLE}
              target="_blank"
              wide
            >
              {intl.formatMessage(msgs.micPermissionDeniedCta)}
            </LinkButton>
          </S.ButtonWrapper>
        </S.Layout>
      </PronunciationViewWrapper>
    );
  }

  return (
    <PronunciationViewWrapper $background="none">
      <S.Layout $compact={compact}>
        <S.MicIconWrapper>
          <Icon name="microphoneOutline" />
        </S.MicIconWrapper>
        <S.TextsWrapper>
          <S.Title>{intl.formatMessage(msgs.micPermissionPromptTitle)}</S.Title>
          <S.Description>{intl.formatMessage(msgs.micPermissionPromptDescription)}</S.Description>
        </S.TextsWrapper>
        <S.ButtonWrapper>
          <Button
            buttonType="primary"
            buttonSize={compact ? 'medium' : 'large'}
            onClick={onClick}
            wide
          >
            {intl.formatMessage(msgs.micPermissionCta)}
          </Button>
        </S.ButtonWrapper>
      </S.Layout>
    </PronunciationViewWrapper>
  );
};
